import { getTvObject, tv } from '@costar-ui/cosmos';

var dialogFooterTV = getTvObject({
  base: ['bg-base', 'border-t', 'border-t-neutral', 'px-8', 'py-4', 'h-16', 'min-h-16', 'gap-6'],
  //base = common styles
  variants: {
    variant: {
      ghost: ['border-t-transparent']
    }
  }
});
var base = {
  base: tv(dialogFooterTV)
};
var dialogFooterStyles = {
  base: base
};

export { dialogFooterStyles, dialogFooterTV };
//# sourceMappingURL=dialog-footer.styles.esm.js.map
